import React from "react";
import { useMsal } from "@azure/msal-react";
import { IconButton } from "@material-ui/core";
import { _t } from "js/utils/TranslationService";
import { providers, ERROR_MESSAGES } from "./types/constants";

const MicrosoftLogo = () => (
  <svg width="22" height="22" viewBox="0 0 24 24">
    <rect width="10" height="10" x="1" y="1" fill="#F25022" />
    <rect width="10" height="10" x="13" y="1" fill="#7FBA00" />
    <rect width="10" height="10" x="1" y="13" fill="#00A4EF" />
    <rect width="10" height="10" x="13" y="13" fill="#FFB900" />
  </svg>
);

const MicrosoftLoginButton = ({ onError, onSubmit, programa }) => {
  const { instance } = useMsal();

  const handleMicrosoftLogin = async () => {
    const loginRequest = {
      scopes: ["user.read"],
      prompt: "select_account"
    };

    try {
      const loginResponse = await instance.loginPopup(loginRequest);
      const accessToken = loginResponse.accessToken;

      const graphResponse = await fetch("https://graph.microsoft.com/v1.0/me", {
        headers: {
          Authorization: `Bearer ${accessToken}`
        }
      });

      const user = await graphResponse.json();

      const credential = {
        email: user.mail,
        name: user.displayName,
        picture: accessToken || "",
        given_name: user.givenName,
        family_name: user.surname
      };
      const provider = providers.MICROSOFT;
      const payload = {
        credential: btoa(JSON.stringify(credential)),
        provider
      };

      await onSubmit({ programa, payload });
    } catch (error) {
      let { message } = error;
      const key = Object.keys(ERROR_MESSAGES).find(key =>
        message.includes(key)
      );
      onError(ERROR_MESSAGES[key] || message);
    }
  };

  return (
    <IconButton
      onClick={handleMicrosoftLogin}
      style={{
        backgroundColor: "#fff",
        border: "1px solid #dadce0",
        margin: "0 8px",
        width: 40,
        height: 40,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
      }}
    >
      <MicrosoftLogo />
    </IconButton>
  );
};

export default MicrosoftLoginButton;
